export default __webpack_public_path__ + "static/media/add-favourite.f4120f70.svg";